import type from './POTemplate.type';

const initialState = {
  templateList: [],
  previewData: null,
  editData: null,
  compData: null,
  factData: null,
  custData: [],
};

const poTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.GET_PO_TEMPLATE:
      return {
        ...state,
        templateList: action.payload,
      };
    case type.GET_PREVIEW_DATA:
      return {
        ...state,
        previewData: action.payload,
      };
    case type.GET_EDIT_DATA:
      return {
        ...state,
        editData: action.payload,
      };
    case type.UPDATED_COMP:
      return {
        ...state,
        compData: action.payload,
      };
    case type.UPDATED_FACT:
      return {
        ...state,
        factData: action.payload,
      };
    case type.UPDATED_CUSTOM:
      return {
        ...state,
        custData: [...state.custData, action.payload],
      };
    case type.CLEAR_DATA:
      return {
        ...state,
        previewData: null,
        editData: null,
        compData: null,
        factData: null,
        custData: [],
      };

    default:
      return state;
  }
};

export default poTemplateReducer;
